export const ssoEditorPath = 'sso-settings';
